import { render, staticRenderFns } from "./apiInsertProduct.vue?vue&type=template&id=477e6ad9&scoped=true&"
import script from "./apiInsertProduct.vue?vue&type=script&lang=js&"
export * from "./apiInsertProduct.vue?vue&type=script&lang=js&"
import style0 from "./apiInsertProduct.vue?vue&type=style&index=0&id=477e6ad9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477e6ad9",
  null
  
)

export default component.exports